import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-fields',
  templateUrl: './contact-fields.component.html',
  styleUrls: ['./contact-fields.component.css']
})
export class ContactFieldsComponent implements OnInit {
  public contactFormGroup: UntypedFormGroup
  public nameControl = new UntypedFormControl('', [Validators.required]);
  public phoneControl = new UntypedFormControl('', [Validators.required]);
  public emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  public companyControl = new UntypedFormControl('', [Validators.required]);
  public messageControl = new UntypedFormControl('', [Validators.required]);

  // Inbox the inquiry is delivered to (backend also CCs alan.delangelfoster@gmail.com).
  private readonly destination = 'info@avantamarketing.com';
  public status: 'loaded' | 'submitting' | 'success' | 'error' = 'loaded';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.contactFormGroup = new UntypedFormGroup({});
    this.contactFormGroup.addControl('name', this.nameControl);
    this.contactFormGroup.addControl('email', this.emailControl);
    this.contactFormGroup.addControl('phone', this.phoneControl);
    this.contactFormGroup.addControl('message', this.messageControl);
    this.contactFormGroup.addControl('company', this.companyControl);
  }

  async sendEmail() {
    if (this.contactFormGroup.invalid) {
      this.contactFormGroup.markAllAsTouched();
      return;
    }

    const v = this.contactFormGroup.value;
    const message = [
      v.company ? `Company: ${v.company}` : '',
      v.phone ? `Phone: ${v.phone}` : '',
      '',
      v.message,
    ].join('\n').trim();

    this.status = 'submitting';
    try {
      // Relative path: Caddy proxies /api/* on this site's domain to shared-api-rs
      // (am-shared on 10.20.20.102:3001), route /api/v1/email.
      await this.http.post('/api/v1/email', {
        name: v.name,
        email: v.email,
        message,
        destination_address: this.destination,
      }, { withCredentials: true }).toPromise();
      this.status = 'success';
      this.contactFormGroup.reset();
    } catch {
      this.status = 'error';
    }
  }
}
